import React, { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
const links = [{
  label: 'For Brands',
  to: '/for-brands'
}, {
  label: 'For Marketing Agencies',
  to: '/for-marketing-agencies'
}, {
  label: 'Case Studies',
  to: '/case-studies'
}, {
  label: 'Resources',
  to: '/resources'
}, {
  label: 'Pricing',
  to: '/pricing'
}];
export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const close = () => setIsOpen(false);
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100" data-id="element-1168" data-mp="ekz2uso6uokr">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1169" data-mp="9j011n83jzpx">
        <div className="flex justify-between items-center h-16" data-id="element-1170" data-mp="1pxrqpsduysvj">
          <div className="flex items-center" data-id="element-1171" data-mp="1kzgitn74isfy">
            <Link to="/" onClick={close} className="flex-shrink-0 flex items-center" data-id="element-1172" data-mp="1kyooefp9j0r9">
              <img src="https://cdn.magicpatterns.com/uploads/gbY7Dn8gGgHtYDAdDbncPd/zano_logo_full1.png" alt="Zano" className="h-7 w-auto" data-id="element-1173" data-mp="9qtxjlr3d5y8" />
            </Link>
            <div className="hidden md:ml-10 md:flex md:space-x-7" data-id="element-1174" data-mp="om9z0bu0444n">
              {links.map(l => <NavLink key={l.to} to={l.to} className={({
              isActive
            }) => `text-sm font-medium transition-colors ${isActive ? 'text-zano-pink' : 'text-gray-600 hover:text-zano-charcoal'}`} data-id="element-1175" data-mp="3n3w04c9oz5lt">
                  {l.label}
                </NavLink>)}
            </div>
          </div>
          <div className="hidden md:flex items-center space-x-4" data-id="element-1176" data-mp="34de8kb0lig21">
            <NavLink to="/list-your-roster" className={({
            isActive
          }) => `text-sm font-medium transition-colors ${isActive ? 'text-zano-pink' : 'text-gray-600 hover:text-zano-charcoal'}`} data-id="element-1177" data-mp="34b1tc5m82jso">
              List Your Roster
            </NavLink>
            <a href="https://app.zanoplatform.com/sign-in" className="text-sm font-medium transition-colors text-gray-600 hover:text-zano-charcoal" data-id="element-1178" data-mp="3b0tehqhnt1yy">
              Login
            </a>
            <Button variant="primary" onClick={() => navigate('/pricing')} data-id="element-1179" data-mp="2ibm7e3453423">
              Start Free Trial
            </Button>
          </div>
          <div className="flex items-center md:hidden" data-id="element-1180" data-mp="2dff98whziwup">
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-600 hover:text-zano-charcoal" data-id="element-1181" data-mp="2sbmqpp20dk6a">
              {isOpen ? <X size={24} data-id="element-1182" data-mp="7kci3omtejgs" /> : <Menu size={24} data-id="element-1183" data-mp="7k48c5lznu9t" />}
            </button>
          </div>
        </div>
      </div>
      {isOpen && <div className="md:hidden bg-white border-b border-gray-100 px-4 pt-2 pb-4 space-y-1" data-id="element-1184" data-mp="2m2mxe13biv6">
          {links.map(l => <NavLink key={l.to} to={l.to} onClick={close} className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-zano-charcoal hover:bg-gray-50" data-id="element-1185" data-mp="a37j1ypt567a">
              {l.label}
            </NavLink>)}
          <NavLink to="/list-your-roster" onClick={close} className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-zano-charcoal hover:bg-gray-50" data-id="element-1186" data-mp="567lydaxrdsb">
            List Your Roster
          </NavLink>
          <div className="mt-4 pt-4 border-t border-gray-100 flex flex-col gap-2" data-id="element-1187" data-mp="k3rl33l5ieqk">
            <a href="https://app.zanoplatform.com/sign-in" onClick={close} data-id="element-1188" data-mp="o41ruigrp96h">
              <Button variant="secondary" className="w-full justify-center" data-id="element-1189" data-mp="1bu5vuqxvbay0">
                Login
              </Button>
            </a>
            <Link to="/pricing" onClick={close} data-id="element-1190" data-mp="1glwbncfkqqwt">
              <Button variant="primary" className="w-full justify-center" data-id="element-1191" data-mp="1gmpa7q4dqa3v">
                Start Free Trial
              </Button>
            </Link>
          </div>
        </div>}
    </nav>;
};